import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import nanoid from 'nanoid';

// eslint-disable-next-line flowtype/no-weak-types
var MessageQueue = /*#__PURE__*/function () {
  function MessageQueue() {
    _classCallCheck(this, MessageQueue);

    _defineProperty(this, "messages", []);

    _defineProperty(this, "subscriber", void 0);
  }

  _createClass(MessageQueue, [{
    key: "emit",
    value: function emit(message) {
      this.messages.push(_objectSpread({
        id: nanoid()
      }, message));

      if (this.subscriber) {
        this.processQueue();
      }
    }
  }, {
    key: "setSubscriber",
    value: function setSubscriber(subscriber) {
      this.subscriber = subscriber;
      this.processQueue();
    }
  }, {
    key: "dequeueMessage",
    value: function dequeueMessage(messageId) {
      this.messages = this.messages.filter(function (message) {
        return message.id !== messageId;
      });
    }
  }, {
    key: "processQueue",
    value: function processQueue() {
      var _this = this;

      this.messages.forEach(function (message) {
        _this.subscriber(message);

        _this.dequeueMessage(message.id);
      });
    }
  }]);

  return MessageQueue;
}();

export { MessageQueue as default };